module.exports = __webpack_public_path__ + "img/forever-link-logo-transparent.4d7aab0d.png";